import React, { useEffect, useState } from "react";
import liveImage from "../stories/assets/course-detail-live-img.png";
import { getCourseLiveData } from "../services/courseService";

export const CourseDetailLive = ({ style }) => {
  const [liveData, setLiveData] = useState(null);

  useEffect(() => {
    const fetchCourseLiveData = async () => {
      const data = await getCourseLiveData();
      setLiveData(data);
    };

    fetchCourseLiveData();
  }, []);

  return (
    <div style={style} className="course-detail-live">
      <img alt="live-image" src={liveImage} />
      <div className="course-detail-live-overlay">
        <div className="course-detail-live-overlay-content white-color px-4">
          <div>
            <span className="font-size-14 font-weight-500 line-height-20 m-0">Live</span>
          </div>
          <p className="font-size-20 font-weight-400 line-height-28 mb-0">{liveData?.name}</p>
          <h4 className="font-size-24 font-weight-500 line-height-32 mt-2 mb-4">{liveData?.title}</h4>
        </div>
      </div>
    </div>
  );
};
